//jshint module : true
const actionTypes = {
    SET_PAGE_TYPE: 'PAGE/SET_PAGE_TYPE',
    SET_PAGE_META: 'PAGE/SET_PAGE_META',
    SET_CATEGORY_PATH: 'PAGE/SET_CATEGORY_PATH',
    SET_CURRENT_CATEGORY_ID: 'PAGE/SET_CURRENT_CATEGORY_ID'
};

const setCategoryPath = categoryPath => {
    return {
        type: actionTypes.SET_CATEGORY_PATH,
        payload: categoryPath
    };
};

const setCurrentCategoryId = categoryId => {
    return {
        type: actionTypes.SET_CURRENT_CATEGORY_ID,
        payload: categoryId
    };
};

const setPageType = type => {
    return {
        type: actionTypes.SET_PAGE_TYPE,
        payload: type
    };
};

const setPageMeta = meta => {
    return {
        type: actionTypes.SET_PAGE_META,
        payload: meta
    };
};

export default {
    actionTypes,
    setPageType,
    setCategoryPath,
    setCurrentCategoryId,
    setPageMeta
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/actions/page.js